import React from 'react'
import { connect } from 'react-redux'

import { Box, Flex } from 'reflexbox'

import {
    Button,
    Card,
    Alert,
    Tag,
    Popover,
    Menu,
    MenuItem,
} from '@blueprintjs/core'

import {
    getDocumentationById,
    saveDocumentation,
    deleteDocumentation,
} from 'src/store/modules/cmdb/documentation'

import * as documentationModules from 'src/store/modules/cmdb/documentation'

const cardStyle = {
    padding: 0.1,
    flexGrow: 1,
    display: 'flex',
    cursor: 'default',
}

class DocumentationCard extends React.Component {
    state = {
        isDeleting: false,
    }

    handleDeleteDocumentation = (confirmed) => {
        if (confirmed) {
            this.props.deleteDocumentation(this.props.documentation.id)
        }
        this.setState({ isDeleting: false })
    }

    renderDocumentationLinks() {
        const {
            availability_zones,
            main_availability_zones,
            documentation,
        } = this.props
        if (availability_zones && main_availability_zones) {
            return (
                <Menu>
                    {availability_zones.map(function (item) {
                        item = item.replace('-', '_')
                        return (
                            <MenuItem
                                key={item}
                                text={item}
                                href={documentation.link + '#Restart_' + item}
                                target="_blank"
                            />
                        )
                    })}
                    <Menu.Divider />
                    {main_availability_zones.map(function (item) {
                        item = item.replace('-', '_')
                        return (
                            <MenuItem
                                key={item}
                                text={item}
                                href={documentation.link + '#Failover_' + item}
                                target="_blank"
                            />
                        )
                    })}
                </Menu>
            )
        }
    }

    render() {
        const { documentation, openEditDocumentationModal } = this.props

        return (
            <Box w={1} p={1}>
                <Card elevation={2} interactive style={cardStyle}>
                    <Flex w={1}>
                        <Box w={3 / 10} p={1}>
                            <Tag fill large icon={'desktop'} intent="primary">
                                {documentation.solution}
                            </Tag>
                        </Box>

                        <Box w={1 / 2} p={1}>
                            <Tag
                                fill
                                large
                                icon={'new-link'}
                                title={documentation.link}
                                intent="primary"
                            >
                                <a
                                    href={documentation.link}
                                    style={{ color: 'white' }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {documentation.link}
                                </a>
                            </Tag>
                        </Box>
                        {this.props.availability_zones &&
                        this.props.main_availability_zones ? (
                            <Box p={1}>
                                <Popover
                                    content={
                                        <Menu>
                                            {this.renderDocumentationLinks()}
                                        </Menu>
                                    }
                                >
                                    <Button icon="book" text="Zones"></Button>
                                </Popover>
                            </Box>
                        ) : null}
                        <Box p={1}>
                            <Button
                                onClick={() =>
                                    openEditDocumentationModal(documentation.id)
                                }
                                icon="edit"
                                minimal
                                intent="warning"
                                title="Edit documentation"
                            />
                        </Box>
                        <Box p={1}>
                            <Button
                                onClick={() =>
                                    this.setState({ isDeleting: true })
                                }
                                icon="trash"
                                minimal
                                intent="danger"
                                title="Delete documentation"
                            />
                        </Box>
                    </Flex>
                    <Alert
                        isOpen={this.state.isDeleting}
                        onClose={this.handleDeleteDocumentation}
                        cancelButtonText="Cancel"
                    >
                        <p>Are you sure you want to delete this document?</p>
                    </Alert>
                </Card>
            </Box>
        )
    }
}

export default connect(
    (state, ownProps) => {
        const documentation = getDocumentationById(
            state,
            ownProps.documentation
        )
        return {
            documentation,
            availability_zones: state.cmdb.documentation.availability_zones,
            main_availability_zones:
                state.cmdb.documentation.main_availability_zones,
        }
    },
    {
        saveDocumentation,
        deleteDocumentation,
        openEditDocumentationModal:
            documentationModules.openEditDocumentationModal,
    }
)(DocumentationCard)
